import PromoCampaignUpdateSecondLine from './PromoCampaignUpdateSecondLine'

export default PromoCampaignUpdateSecondLine
